import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Onboarding from './Onboarding';
import SetupRecs from '../components/SetupRecs/SetupRecs';
import SupportRow from '../components/Onboarding/SupportRow';
import {
  onboardingRecsPreview,
  onboardingRecsCustomize,
  onboardingRecsActivate,
} from '../slices/OnboardingSlice';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

function buildCards(history, shopId, t) {
  return [
    {
      id: 'step1',
      header: t('ui.onboardingRecs.safelyPreviewRecommendations'),
      buttonColor: '#1E2248',
      buttonText: t('onboarding.action.preview'),
      buttonIcon: 'search',
      buttonOnClick: () => {
        const previewWin = window.open('about:blank', '_blank');
        return onboardingRecsPreview(previewWin);
      },
      meta: t('onboarding.recs.preview.description'),
    }, {
      id: 'step2',
      header: t('ui.onboardingRecs.customizeRecommendationsAndStyle'),
      buttonColor: '#1E2248',
      buttonText: t('onboarding.action.customize'),
      buttonIcon: 'edit',
      buttonOnClick: () => {
        history.push(`/app/${shopId}/recs/settings`);
        return onboardingRecsCustomize();
      },
      meta: t('onboarding.recs.customize.description'),
    }, {
      id: 'step3',
      header: t('ui.onboardingRecs.makeRecommendationsEnabledForYourCustomers'),
      buttonColor: 'green',
      buttonText: t('onboarding.action.activate'),
      buttonIcon: 'boat',
      buttonOnClick: () => {
        history.push(`/app/${shopId}/recs/dashboard`);
        return onboardingRecsActivate();
      },
      meta: t('onboarding.recs.activate.description'),
    },
  ];
}

export default function OnboardingRecs() {
  const store = useSelector((store) => store);
  const { shopId } = store.settings;
  const { onboarding } = store;
  const history = useHistory();
  const t = useLocalizedMessage();
  const cards = buildCards(history, shopId, t);

  useEffect(() => {
    if (onboarding.recs.completed && onboarding.recs.wizardCompleted) {
      history.replace(`/app/${shopId}/recs/dashboard`);
    }
  }, [
    history,
    onboarding.recs.completed,
    onboarding.recs.wizardCompleted,
    shopId,
  ]);

  if (!onboarding.recs.wizardCompleted) {
    return (
      <>
        <SetupRecs />
        <Grid container justifyContent="center" spacing={4}>
          <Grid item xs={9}>
            <SupportRow />
          </Grid>
        </Grid>
      </>
    );
  }

  if (!onboarding.recs.completed) {
    return (
      <Onboarding
        cards={cards}
        header={t('onboarding.recs.title')}
        subheader1={t('onboarding.recs.description')}
        subheader2={t('onboarding.recs.stepsDescription')}
      />
    );
  }

  return null;
}
